import { checkRoleManager } from '@/helpers/roles'
import { offerStatus } from '@/settings/offers'

export function checkCanEditContract(user, entityId) {
  let entity

  if (!checkRoleManager(user.role) || user.entities === undefined) return false;

  if (entityId) {
    entity = user.entities.find(entity => entity.id === entityId);

    return entity && entity.can_edit_contract;
  }

  for (entity of user.entities) {
    if (entity.can_edit_contract) return true;
  }

  return false;
}

export function canEditOfferContractFields(offer, user, entityId) {
  return (
    checkCanEditContract(user, entityId) &&
    offer.status === offerStatus.validated &&
    offer.applied_candidates && offer.applied_candidates.length > 0 &&
    offer.applied_candidates[0].user_info.resource_type === 'extern'
  )
}

export function getContractTemplatesByEntityId({ entityId, templates }) {
  return templates.filter(template => template.entity_id === entityId)
}



// WEBPACK FOOTER //
// ./src/helpers/contracts.js